import {register} from '@shopify/theme-sections';

export default register('featured-video', {

  onLoad() {

    // POST commands to YouTube or Vimeo API
    function postMessageToPlayer(player, command) {
      if (player == null || command == null) {
        return;
      }
      player.contentWindow.postMessage(JSON.stringify(command), '*');
    }

    var playButton = this.container.querySelector('.btn--play');
    var videoText = this.container.querySelector('.featured-video__text-container');
    var videoImage = this.container.querySelector('.featured-video__image');
    var videoContainer = this.container.querySelector('.featured-video__video');
    var player = videoContainer.querySelector('iframe');

    var self = this;

    playButton.addEventListener('click', function() {
      self.container.classList.add('featured-video--visible');
      videoText.classList.add('visually-hidden');
      videoImage.classList.add('visually-hidden');
      videoContainer.classList.remove('visually-hidden');
      player.src += "&autoplay=1";

      postMessageToPlayer(player, {
        method: 'play',
      });
    });
  },

});
